export const analyticCookies = i18n => ({
  groupKey: 'ANALYTICS',
  icon: 'images/cookie-settings/analytics-cookies-icon.svg',
  title: i18n.t('cookieSettings.analytics.title'),
  description: i18n.t('cookieSettings.analytics.description'),
  cookies: [
    {
      name: 'Amplitude',
      provider: 'Amplitude Inc',
      purpose: i18n.t('cookieSettings.analytics.amplitude.purpose'),
      privacyPolicy:
        'https://help.amplitude.com/hc/en-us/articles/206533238-Data-Security-Privacy/'
    },
    {
      name: 'Hotjar',
      provider: 'Hotjar Ltd.',
      purpose: i18n.t('cookieSettings.analytics.hotjar.purpose'),
      privacyPolicy: 'https://www.hotjar.com/legal/policies/privacy/'
    },
    {
      name: 'Segment',
      provider: 'Segment.io Inc',
      purpose: i18n.t('cookieSettings.analytics.segment.purpose'),
      privacyPolicy: 'https://segment.com/legal/privacy/'
    }
  ]
})
